module.exports = __webpack_public_path__ + "static/media/logo1.837c1de0.png";